import { ref, watch } from "vue";
import Odometer from "odometer";
import { CasinoJackpotType } from "../jackpots/casino-jackpot";
import useJackpotManager from "../jackpots/use-jackpot-manager";
import { onViewportEnter } from "@sazka/utils/viewport-enter";
import { StringUtils } from "@sazka/utils/string-utils";

async function initGameJackpotCarousel(root: HTMLElement) {
    const odometers = ref(new Map());
    const jackpotAmountElements = [...root.querySelectorAll<HTMLElement>("[data-jackpot-provider]")];
    const jackpotProviders = jackpotAmountElements.map((el) => el.dataset.jackpotProvider as CasinoJackpotType);

    const BATCH_SIZE = 5;

    if (!environment.isLowPerformanceDevice) {
        for (let i = 0; i < jackpotAmountElements.length; i += BATCH_SIZE) {
            const batch = jackpotAmountElements.slice(i, i + BATCH_SIZE);

            batch.forEach((amountElement) => {
                const defaultAmount = +amountElement.dataset.defaultAmount;
                const odometer = new Odometer({
                    el: amountElement,
                    value: defaultAmount,
                    duration: 4000,
                    format: "( ddd)",
                });
                odometers.value.set(amountElement.dataset.jackpotProvider, odometer);
            });

            if (i + BATCH_SIZE < jackpotAmountElements.length) {
                await new Promise((resolve) => setTimeout(resolve, 0));
            }
        }
        odometers.value.forEach((odometer) => odometer.render());
    }

    const { jackpots, subscribe } = await useJackpotManager(jackpotProviders);
    subscribe();

    jackpotProviders.forEach((provider) => {
        watch(
            () => jackpots.jackpotsByProvider[provider],
            (jackpotData) => {
                const maxAmount = Math.max(...jackpotData.map((item) => item.prize));
                const roundedAmount = Math.round(maxAmount);

                const odometer = odometers.value.get(provider);
                if (odometer && odometer.value !== roundedAmount && !environment.isLowPerformanceDevice) {
                    odometer.update(roundedAmount);
                } else if (environment.isLowPerformanceDevice) {
                    const jackpotAmountElement = jackpotAmountElements.filter(
                        (el) => el.dataset.jackpotProvider === provider
                    );
                    jackpotAmountElement.forEach((el) => {
                        el.innerHTML = StringUtils.formatNumber(roundedAmount, true);
                    });
                }
            }
        );
    });
}

document.ready(() => {
    const gameJackpotCarouselRoots = document.querySelectorAll<HTMLElement>(".games-jackpot-carousel");

    if (!gameJackpotCarouselRoots.length) return;

    gameJackpotCarouselRoots.forEach((gameJackpotCarouselRoot) =>
        onViewportEnter(gameJackpotCarouselRoot, 0.2, "40px").then(() =>
            initGameJackpotCarousel(gameJackpotCarouselRoot)
        )
    );
});
